import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "@/authConfig"

export const msalInstance = new PublicClientApplication(msalConfig);

export async function initializeMsal() {
    try {
        if (!msalInstance || !msalInstance.initialize) {
            console.error("MSAL instance is undefined or not properly constructed.");
            return null;
        }
        await msalInstance.initialize();
        return msalInstance;
    } catch (error) {
        return null;
    }
}